<template>
  <p><strong>Jak ře&scaron;&iacute;me va&scaron;e st&iacute;žnosti</strong></p>
  <p>
    Je pro n&aacute;s nesm&iacute;rně důležit&eacute;, abyste si pečlivě přečetli n&iacute;že
    uveden&eacute; informace a plně porozuměli tomu, jak ře&scaron;&iacute;me va&scaron;e
    st&iacute;žnosti!
  </p>
  <p>
    Draph Solutions S.r.o. je společnost registrovan&aacute; v Česk&eacute; republice
    (&bdquo;CZ&ldquo;) s identifikačn&iacute;m č&iacute;slem C 278807, se s&iacute;dlem na adrese
    Národní 961/25, Staré Město, 110 00 Praha 1 (d&aacute;le jen &bdquo;Draph&ldquo;,
    &bdquo;my&ldquo; nebo &bdquo;n&aacute;s&ldquo;).
  </p>
  <p>Poskytujeme na&scaron;e služby pod obchodn&iacute;m n&aacute;zvem &bdquo;Swipez&ldquo;.</p>
  <p>
    Nab&iacute;z&iacute;me platebn&iacute; služby jako poskytovatel platebn&iacute;ch služeb
    mal&eacute;ho rozsahu (&bdquo;SSP&ldquo;). Jsme opr&aacute;vněni a regulov&aacute;ni Českou
    n&aacute;rodn&iacute; bankou (&bdquo;ČNB&ldquo;).
  </p>
  <p>
    Na&scaron;e obchodn&iacute; činnost, poskytov&aacute;n&iacute; služeb a vztahy s klienty i ČNB
    se ř&iacute;d&iacute; platn&yacute;mi z&aacute;kony Česk&eacute; republiky.
  </p>
  <p>
    Vyz&yacute;v&aacute;me na&scaron;e klienty, aby n&aacute;s informovali o jak&yacute;chkoliv
    z&aacute;ležitostech, pokud maj&iacute; pocit, že jejich oček&aacute;v&aacute;n&iacute; nebyla
    naplněna, nebo pokud maj&iacute; obavy ohledně n&aacute;mi poskytovan&yacute;ch služeb.
  </p>
  <p>
    Poskytov&aacute;n&iacute; služeb na vysok&eacute; &uacute;rovni je pro n&aacute;s
    nejvy&scaron;&scaron;&iacute; prioritou. Snaž&iacute;me se budovat dlouhodob&eacute; vztahy s
    na&scaron;imi klienty t&iacute;m, že jim kdykoliv poskytujeme podporu, a proto bereme
    v&scaron;echny st&iacute;žnosti velmi v&aacute;žně. Na&scaron;&iacute;m z&aacute;vazkem vůči
    v&aacute;m je, že va&scaron;i st&iacute;žnost pro&scaron;etř&iacute;me a vyře&scaron;&iacute;me
    ji rychle a spravedlivě.
  </p>
  <p>
    N&iacute;že naleznete pokyny t&yacute;kaj&iacute;c&iacute; se způsobu, jak&yacute;m
    přij&iacute;m&aacute;me, pro&scaron;etřujeme a posuzujeme st&iacute;žnosti
    souvisej&iacute;c&iacute; s poskytov&aacute;n&iacute;m na&scaron;ich služeb.
  </p>
  <p><span lang="pl-PL">Va&scaron;e st&iacute;žnosti budou posouzeny bezplatně.</span></p>
  <p>
    <span lang="pl-PL"
      >V př&iacute;padě jak&eacute;koli st&iacute;žnosti t&yacute;kaj&iacute;c&iacute; se
      na&scaron;ich služeb se nejprve obraťte na n&aacute;&scaron; t&yacute;m
      z&aacute;kaznick&eacute; podpory prostřednictv&iacute;m e-mailov&eacute; adresy
      support@swipez.com. Můžete n&aacute;s tak&eacute; kontaktovat prostřednictv&iacute;m
      sv&eacute;ho profilu v na&scaron;em syst&eacute;mu. N&aacute;&scaron; t&yacute;m
      z&aacute;kaznick&eacute; podpory v&aacute;m pomůže rychle a efektivně vyře&scaron;it
      různ&eacute; probl&eacute;my nebo v př&iacute;padě potřeby neprodleně před&aacute;
      v&aacute;&scaron; požadavek př&iacute;slu&scaron;n&eacute;mu oddělen&iacute; společnosti
      Draph.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Pokud probl&eacute;m nebude vyře&scaron;en k va&scaron;&iacute; spokojenosti
      prostřednictv&iacute;m na&scaron;eho t&yacute;mu z&aacute;kaznick&eacute; podpory, můžete
      podat form&aacute;ln&iacute; st&iacute;žnost e-mailem na adresu info@swipez.eu.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Upozorňujeme, že st&iacute;žnost je nutn&eacute; podat p&iacute;semně, s uveden&iacute;m
      okolnost&iacute; sporu a va&scaron;&iacute; ž&aacute;dosti.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Při pod&aacute;n&iacute; st&iacute;žnosti od v&aacute;s oček&aacute;v&aacute;me
      poskytnut&iacute; n&aacute;sleduj&iacute;c&iacute;ch &uacute;dajů:</span
    >
  </p>
  <ul>
    <li>
      <p>va&scaron;e cel&eacute; jm&eacute;no,</p>
    </li>
    <li>
      <p>č&iacute;slo va&scaron;eho &uacute;čtu,</p>
    </li>
  </ul>
  <p>&nbsp;</p>
  <ul>
    <li>
      <p>telefonn&iacute; č&iacute;slo přiřazen&eacute; k va&scaron;emu &uacute;čtu,</p>
    </li>
    <li>
      <p>e-mailovou adresu přiřazenou k va&scaron;emu &uacute;čtu,</p>
    </li>
    <li>
      <p>
        podrobn&yacute; popis okolnost&iacute;, kter&eacute; vedly ke st&iacute;žnosti, včetně
        &uacute;pln&eacute;ho popisu probl&eacute;mu, data a času, kdy k němu do&scaron;lo, a
        va&scaron;eho preferovan&eacute;ho způsobu ře&scaron;en&iacute;,
      </p>
    </li>
    <li>
      <p>
        přiložen&eacute; podpůrn&eacute; dokumenty pomohou urychlit vy&scaron;etřov&aacute;n&iacute;
        př&iacute;padu a umožn&iacute; komplexn&iacute; přezkum v&scaron;ech
        souvisej&iacute;c&iacute;ch detailů.
      </p>
    </li>
  </ul>
  <p>
    Přijet&iacute; st&iacute;žnosti potvrd&iacute;me p&iacute;semně e-mailem nejpozději do 48
    (čtyřicet osm) hodin od jej&iacute;ho obdržen&iacute;.
  </p>
  <p>
    Pokud si svou st&iacute;žnost rozmysl&iacute;te a budete ji cht&iacute;t st&aacute;hnout, dejte
    n&aacute;m pros&iacute;m vědět e-mailem nebo prostřednictv&iacute;m sv&eacute;ho profilu v
    syst&eacute;mu. Důvod stažen&iacute; st&iacute;žnosti z na&scaron;&iacute; strany
    ocen&iacute;me.
  </p>
  <p>
    Po obdržen&iacute; v&scaron;ech podrobnost&iacute; va&scaron;&iacute; st&iacute;žnosti ji
    neprodleně posoud&iacute;me a poskytneme v&aacute;m konečnou odpověď do 15 (patn&aacute;cti)
    pracovn&iacute;ch dnů. Pokud bude nutn&eacute; z&iacute;skat jak&eacute;koli dodatečn&eacute;
    informace pro ř&aacute;dn&eacute; vyře&scaron;en&iacute; probl&eacute;mu, budeme v&aacute;s
    kontaktovat a sděl&iacute;me v&aacute;m, jak&eacute; dal&scaron;&iacute; informace nebo
    dokumenty jsou vyžadov&aacute;ny. Upozorňujeme, že jak&eacute;koli zpožděn&iacute;
    způsoben&eacute; nedostatečn&yacute;mi informacemi nebude br&aacute;no v &uacute;vahu při
    posuzov&aacute;n&iacute;, zda byla konečn&aacute; odpověď poskytnuta do 15 (patn&aacute;cti)
    pracovn&iacute;ch dnů.
  </p>
  <p>
    Pokud nebudeme schopni poskytnout konečnou odpověď na va&scaron;i st&iacute;žnost do 15
    (patn&aacute;cti) pracovn&iacute;ch dnů, budeme v&aacute;s kontaktovat s vysvětlen&iacute;m
    důvodů zpožděn&iacute; a uvedeme datum, kdy od n&aacute;s obdrž&iacute;te konečnou odpověď. V
    každ&eacute;m př&iacute;padě v&aacute;m konečnou odpověď poskytneme nejpozději do 35 (třicet
    pět) pracovn&iacute;ch dnů ode dne přijet&iacute; st&iacute;žnosti.
  </p>
  <p>
    Na&scaron;e konečn&aacute; odpověď bude jasně označena jako takov&aacute; a bude obsahovat jednu
    z n&aacute;sleduj&iacute;c&iacute;ch možnost&iacute;:
  </p>
  <ul>
    <li>
      <p>
        Přijet&iacute; va&scaron;&iacute; st&iacute;žnosti a v př&iacute;padě potřeby nab&iacute;dku
        vr&aacute;cen&iacute; finančn&iacute;ch prostředků nebo jinou formu kompenzace,
      </p>
    </li>
    <li>
      <p>
        Nab&iacute;dku kompenzace jako projev dobr&eacute; vůle bez přijet&iacute;
        va&scaron;&iacute; st&iacute;žnosti,
      </p>
    </li>
    <li>
      <p>
        Zam&iacute;tnut&iacute; va&scaron;&iacute; st&iacute;žnosti s vysvětlen&iacute;m důvodů
        jej&iacute;ho zam&iacute;tnut&iacute;.
      </p>
    </li>
  </ul>
  <p>
    Pokud nebudete spokojeni s na&scaron;&iacute; odpověd&iacute; nebo pokud v&aacute;m
    neodpov&iacute;me do 35 (třiceti pěti) pracovn&iacute;ch dnů, můžete věc postoupit Česk&eacute;
    n&aacute;rodn&iacute; bance e-mailem na podatelna@cnb.cz, po&scaron;tou na adresu
    Senov&aacute;žn&aacute; 3, 115 03 Praha 1, prostřednictv&iacute;m datov&eacute; schr&aacute;nky
    &ndash; ID datov&eacute; schr&aacute;nky: 8tgaiej nebo elektronicky přes odkaz:
    <a href="https://www.cnb.cz/en/public/contacts/electronic-form/"
      >https://www.cnb.cz/en/public/contacts/electronic-form/</a
    >.
  </p>
  <p>
    Můžete se tak&eacute; obr&aacute;tit na Veřejn&eacute;ho ochr&aacute;nce pr&aacute;v (Ombudsman)
    na webov&yacute;ch str&aacute;nk&aacute;ch
    <a href="https://www.ochrance.cz">www.ochrance.cz</a>, adresa &Uacute;doln&iacute; 39, 602 00
    Brno, e-mailov&aacute; adresa podatelna@ochrance.cz, ID datov&eacute; schr&aacute;nky: jz5adky,
    telefon (+420) 542 542 888.
  </p>
  <p>
    <span lang="pl-PL"
      >Usilovně pracujeme na tom, abyste nikdy neměli důvod si na na&scaron;e služby stěžovat!</span
    >
  </p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
</template>
